// Types and helpers shared by the React components.

/** The palette hues that work as colour modifiers. Keep in sync with $hues in scss/_variables.scss. */
export const HUES = [
  'cyan',
  'aqua',
  'blue',
  'teal',
  'navy',
  'slate',
  'grey',
  'green',
  'mint',
  'red',
  'orange',
  'amber',
  'purple',
  'pink',
  'imperial',
  'republic',
  'frogdog',
  'rotworm',
  'discord',
] as const;
export type Hue = (typeof HUES)[number];

/** Every palette colour ($colors in scss/_variables.scss): each hue with its variants, plus the rest. */
export type Colour =
  | Hue
  | `${Hue}-light`
  | `${Hue}-dark`
  | 'cyan-pale'
  | 'space'
  | 'midnight'
  | 'white'
  | 'black'
  | 'gold'
  | 'silver'
  | 'bronze'
  | 'frogdog-outline'
  | 'rotworm-outline'
  | `quality-${'artifact' | 'cheap' | 'currency' | 'legacy' | 'legendary' | 'mission' | 'moddable' | 'premium' | 'prototype' | 'standard'}`;

/** Opacity steps (multiples of 5), as used by .o-* and component opacity modifiers. */
export type Opacity =
  | 0 | 5 | 10 | 15 | 20 | 25 | 30 | 35 | 40 | 45 | 50
  | 55 | 60 | 65 | 70 | 75 | 80 | 85 | 90 | 95 | 100;

/** Size modifier names shared by every component (base is the default, no class). */
export type Size = 'xs' | 'sm' | 'base' | 'md' | 'lg' | 'xl';

export type Breakpoint = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

/** Joins class names, skipping falsy values. */
export function cx(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}

/** `${block}--${size}`, or nothing for the default base size. */
export const sizeClass = (block: string, size?: string) => (size && size !== 'base' ? `${block}--${size}` : undefined);
